module.exports = __webpack_public_path__ + "muli-webfont.ecc47d611c75f0a57d38.woff2";


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/koraal-mijnmening-backoffice/checkout/src/assets/fonts/muli/muli-webfont.woff2
// module id = ../../../../../src/assets/fonts/muli/muli-webfont.woff2
// module chunks = styles